var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"description":_vm.content.description,"title":_vm.content.title,"svg-path":_vm.emptyStateSvgPath,"svg-height":_vm.content.svgHeight,"data-testid":"issuable-empty-state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }